import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { handleApiErrors, InputType } from "../../Utils/Utils";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import DynamicService from "../../Services/DynamicService";
import RoutesPath from "../../Utils/RoutesPath";
import { useNavigate } from "react-router-dom";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import DatePicker from "react-datepicker";
import Calanderimg from "../../assets/images/png/fi_12671954.png";
import * as XLSX from "xlsx";
import { AuthContext } from "../../Context/authContext";
import DataProvider from "../../Utils/DataProvider";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import DistrictService from "../../Services/DistrictService";
import TalukaService from "../../Services/TalukaService";

const PackagePurchased = () => {
  const [data, setData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [searchDistrict, setSearchDistrict] = useState(null);
  const [searchTaluka, setSearchTaluka] = useState(null);
  const [searchPackage, setSearchPackage] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [details, setDetails] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [deleteId, setDeleteId] = useState("");
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { user } = useContext(AuthContext);
  const [districts, setDistricts] = useState([]);
  const [filterDistricts, setFilterDistricts] = useState([]);
  const [resetDistrict, setResetDistrict] = useState(false);
  const [resetFilterDistrict, setResetFilterDistrict] = useState(false);
  const [selectedDistrictFilter, setSelectedDistrictFilter] = useState("");
  const [talukas, setTalukas] = useState([]);
  const [filterTalukas, setFilterTalukas] = useState([]);
  const [resetTaluka, setResetTaluka] = useState(false);
  const [resetFilterTaluka, setResetFilterTaluka] = useState(false);
  const [selectedTalukaFilter, setSelectedTalukaFilter] = useState("");

  const [count, setCount] = useState(1);

  const navigate = useNavigate();

  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  const CustomDateInput = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="From"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );
  const CustomDateInputTo = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="To"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );

  const fetchData = async () => {
    try {
      const response = await DynamicService.getAllPurchasePackage(
        offset,
        limit,
        searchQuery || "",
        searchPackage || "",
        selectedDistrictFilter.name || "",
        selectedTalukaFilter || "",
        startDate,
        endDate
      );
      setData(response.data);
      setAvailableDataCount(response.availableDataCount);

      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const getAllStudentPackagePurchasedWithoutPagination = async () => {
    try {
      const response = await DynamicService.getAllStudentPackagePurchasedWithoutPagination();
      setDataExport(response.data);
      // setAvailableDataCount(response.availableDataCount);
      
    } catch (error) {
      handleApiErrors(error);
    }
  };
  useEffect(() => {
    fetchData();
    getAllFilterDistricts()
    getAllStudentPackagePurchasedWithoutPagination()
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (
        searchQuery != null ||
        selectedDistrictFilter != null ||
        selectedTalukaFilter != null||
        searchPackage!=null
      ) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery, selectedDistrictFilter, selectedTalukaFilter,searchPackage]);

  const removeTimeFromDate = (dateString) => {
    if (!dateString) return "";
    const dateObject = new Date(dateString);
    // Ensure the date is parsed as UTC
    const utcYear = dateObject.getUTCFullYear();
    const utcMonth = dateObject.toLocaleString("default", {
      month: "long",
      timeZone: "UTC",
    });
    const utcDay = dateObject.getUTCDate();
    return `${utcDay} ${utcMonth} , ${utcYear}`;
  };


  useEffect(() => {
    const fetchStudentPackagePurchasedByDate = () => {
      if (startDate || endDate) {
        fetchData(startDate, endDate);
      }
    };

    const timeoutId = setTimeout(fetchStudentPackagePurchasedByDate, 500); // Debounce the request

    return () => clearTimeout(timeoutId); // Clear timeout if date changes again quickly
  }, [startDate, endDate]);

  const exportToExcel = (data, fileName) => {
    if (!data || data.length === 0) {
      toast.info("No data to export");
      return;
    }

    // Create a worksheet from data
    const ws = XLSX.utils.json_to_sheet(data);


    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to file
    XLSX.writeFile(wb, fileName);
  };

  const handleExportClick = () => {
    const name = user.name || "";
    const fileName = `${name} Purchase Details.xlsx`;
    exportToExcel(dataExport, fileName);
  };


  const truncatePackageNames = (packages) => {
    if (!packages || packages.length === 0) return "No Packages";

    const packageNames = packages.map((pkg) => pkg.packageName);
    const totalCount = packageNames.length;

    // Return JSX for display
    if (totalCount > 1) {
      return (
        <>
          <span>{packageNames[0]}...</span>
          <span style={{ fontWeight: "bold", color: "black" }}>
            {" "}
            & {totalCount - 1} more
          </span>
        </>
      ); // Show first name with ellipsis and count of remaining in bold
    }

    return <span>{packageNames[0]}</span>; // Return the first package name if it's the only one
  };

  const getAllFilterDistricts = async () => {
    try {
      const response = await DistrictService.getAll();
      setFilterDistricts(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const getAllFilterTalukas = async (district_id) => {
    try {
      const response = await TalukaService.getAll(district_id);
      setFilterTalukas(district_id ? response.data : []);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0 text-uppercase">
          {" "}
          Student Package Purchased
        </h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">
            {" "}
            Package Purchased Listing
          </h4>
        </div>
      </div>
      {details?.classId ? (
        <div className="table_container">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="black fs-18 fw-600 mb-0">Student Details</h1>
            <div className=" d-flex align-items-center justify-content-end respoexportbtn ">
              <ButtonWithIcon
                text={"Edit"}
                icon={SvgImages.edit}
                onClick={() => {

                  const reportsPrivilege = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Reports"
                  );
                  if (!reportsPrivilege?.update) {
                    // If the user does not have delete permission, show a toast warning
                    toast.warning("You don't have permission to edit students.");
                    return;
                  }
                  navigate(
                    `${RoutesPath.editstudentdetails}/${details.user_id || details.userId}`,
                    { state: details, }
                  );
                }}
              />
            </div>
          </div>

          <div className=" fs-16 fw-600 mt-3 mb-3 blue">Personal Details</div>
          <div className="rounded shadow ">
            {" "}
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">
                  <tr>
                    <th style={{ width: "20%" }}>First Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.userName}
                    </td>
                    <th style={{ width: "20%" }}>Middle Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.middleName ? (
                        details.middleName
                      ) : (
                        <span className="blue">Not Available...</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>Last Name</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.lastName}
                    </td>
                    <th style={{ width: "20%" }}>Date of Birth</th>
                    <td style={{ width: "20%" }}>
                      {removeTimeFromDate(details?.dateOfBirth)}
                    </td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Gender</th>
                    <td style={{ width: "20%" }}>{details?.gender}</td>
                    <th style={{ width: "20%" }}>School Name</th>
                    <td style={{ width: "20%" }}>{details?.schoolName}</td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Medium</th>
                    <td style={{ width: "20%" }}>{details?.medium}</td>
                    <th style={{ width: "20%" }}>Class</th>
                    <td style={{ width: "20%" }}>{details?.className}</td>
                  </tr>{" "}
                </thead>
              </table>
            </div>
          </div>
          <div className=" fs-16 fw-600 mt-3 mb-3 blue">Contact Details</div>
          <div className="rounded shadow ">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0  table-bordered"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead className="border">
                  <tr>
                    <th style={{ width: "20%" }}>Email</th>
                    <td style={{ width: "20%" }}>{details?.email}</td>
                    <th style={{ width: "20%" }}>Mobile</th>
                    <td style={{ width: "20%" }}>{details?.mobile}</td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>Address Line-1 </th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.addressLineOne}
                    </td>
                    <th style={{ width: "20%" }}>Address Line-2</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.addressLineTwo}
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: "20%" }}>State</th>
                    <td style={{ width: "20%" }}>{details?.state}</td>
                    <th style={{ width: "20%" }}>District</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.district ? (
                        details.district
                      ) : (
                        <span className="blue">Not Available...</span>
                      )}
                    </td>
                  </tr>{" "}
                  <tr>
                    <th style={{ width: "20%" }}>Taluka</th>
                    <td className="text-capitalize" style={{ width: "20%" }}>
                      {details?.taluka ? (
                        details.taluka
                      ) : (
                        <span className="blue">Not Available...</span>
                      )}
                    </td>
                    <th style={{ width: "20%" }}>Pin Code</th>
                    <td style={{ width: "20%" }}>
                      {details?.pinCode ? (
                        details.pinCode
                      ) : (
                        <span className="blue">Not Available...</span>
                      )}
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>

          <div className="mt-5">
            <h1 className="black fs-18 fw-600 mb-2">
              Details of Package Purchased
            </h1>
          </div>
          <div className="row align-items-start mt-3">
            <div
              className="col-md-12 col-lg-7"
              style={{ overflowX: "auto", overflowY: "auto", height: "420px" }}
            >
              <table
                className="table mb-0 mt-3 "
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                {/* <thead>
                                    <tr className="table_heading">
                                        <th scope="col" style={{ width: "5%" }}>Sr No.</th>
                                        <th scope="col" style={{ width: "30%" }}>Package Name</th>
                                        <th scope="col" style={{ width: "10%" }}>Amount</th>
                                    </tr>
                                </thead> */}

                <thead>
                  <tr className="table_heading">
                    <th scope="col" style={{ width: "5%" }}>
                      Sr No.
                    </th>
                    <th scope="col" style={{ width: "5%" }}>
                      Purchased Date
                    </th>
                    <th scope="col" style={{ width: "15%" }}>
                      Package Name
                    </th>
                    <th scope="col" style={{ width: "15%" }}>
                      Order Id
                    </th>
                    <th scope="col" style={{ width: "10%" }}>
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody className="bg_light">
                  {details.packages?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.orderDate}</td>
                        <td title={item.packageName}>{item.packageName}</td>
                        <td>{item.order_id}</td>
                        <td>{item.amount}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div
              className=" mt-3 col-md-12 col-lg-5 align-items-center align-self-top"
              style={{
                backgroundColor: "#f3f5f6",
                borderRadius: "20px",
                padding: "26px 30px",
              }}
            >
              <p className="sub-large-text fs-18 fw-600 blue">Order Summary</p>
              <div className="hrline2 text-dark">
                <div className="justify-content-between d-flex py-2 small-medium-text fw-500 ">
                  <div className="fs-14 fw-400">Subtotal</div>
                  <div className="fw-500">₹ {details.subTotal}</div>
                  {/* <div className='fw-500'>₹ 1599</div> */}
                </div>
                <div className="justify-content-between d-flex py-2 small-medium-text fw-500 ">
                  <div className="fs-14 fw-400">Discount</div>
                  <div className="fw-500 greenyes">
                    - ₹ {details.discountAmt}
                  </div>
                  {/* <div className='fw-500 greenyes'>- ₹ 240</div> */}
                </div>
              </div>
              <div className="justify-content-between d-flex fw-600 small-medium-text border-top pt-3 mb-2 ">
                <div className="fs-14 fw-400">Total Amount:</div>
                <div className="fw-500">₹ {details.totalAmt}</div>
                {/* <div className='fw-500'>₹ 1646</div> */}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-start">
            <div
              className="blue cursor-pointer mt-3 fw-500 fs-14"
              onClick={() => {
                setDetails(null)
              }}
            >
              {" "}
              <Image src={SvgImages.left_arrow} className="blue mx-3" />
              Back
            </div>
          </div>
        </div>
      ) : (
        <div className="table_container" style={{ display: "block" }}>
          {/* <h1 className="black fs-18 fw-600 mb-0">BharaSatExam Listing</h1> */}

          <div className="table_title">
            <div className="table_headings">
              <h1 className="black fs-18 fw-600 mb-0">

              </h1>
              <div className="d-flex gap-4 align-items-center ">
                <div className="position-relative ">
                  <input
                    type="search"
                    className="search_box search_bar"
                    placeholder="Search"
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <Image
                    src={SvgImages.search}
                    style={ImageFilters.gray}
                    className="search_icon"
                    alt="Search Icon"
                    height="20px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className=" row table_title align-items-center responsivetablepackagetwo">
            <div className="col-lg-6 col-md-12 col-xl-3 gap-2 col-12 pe-0 d-flex  align-items-center sectionPayouts  datepickerstyle">
              <div className="">Date:</div>
              <div>
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                  placeholderText="From"
                  maxDate={new Date()}
                  customInput={<CustomDateInput />}
                />
              </div>
              <div>
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                  placeholderText="To"
                  minDate={startDate}
                  maxDate={new Date()}
                  customInput={<CustomDateInputTo />}
                />
              </div>
            </div>
            <div className="col-xl-7 my-2 col-lg-12 col-md-12 gap-2 Responsivesearchbars  align-items-center d-flex">
              <div className=" col-md-8 col-lg-4 col-sm-12 ">
                <CustomTextField
                  placeholder="Search Package"
                  inputType={InputType.text}
                  additionalClasses="profile_edit"
                  optionalclass="marginbtm"
                  value={searchPackage || ""}
                  onChange={(e) => {
                    setSearchPackage(e.target.value);
                  }}
                />
              </div>
              <div className=" col-md-8 col-lg-4 col-sm-12 ">
                <CustomDropDown
                  placeholder="Select District"
                  inputType={InputType.text}
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  resetValue={resetFilterDistrict}
                  setResetValue={setResetFilterDistrict}
                  onChange={(e) => {
                    const selected = filterDistricts.find(d => d._id === e.value)
                    setSelectedDistrictFilter({
                      id: selected?._id || "",
                      name: selected?.name || ""
                    });
                    setResetFilterTaluka(true);
                    setSelectedTalukaFilter("");
                    getAllFilterTalukas(selected?._id || "");
                    setOffset(0);
                  }}
                  options={[
                    { value: "", label: "All" },
                    ...filterDistricts?.map((e) => ({
                      value: e._id,
                      label: e.name,
                    })) ?? [],
                  ]}
                  defaultOption={{ value: selectedDistrictFilter._id, label: selectedDistrictFilter.name || "Select District" }}
                />
              </div>

              <div className="col-md-8 col-lg-4  col-sm-12">
                <CustomDropDown
                  placeholder="Select Taluka"
                  inputType={InputType.text}
                  resetValue={resetFilterTaluka}
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  setResetValue={setResetFilterTaluka}
                  onChange={(e) => {
                    setSelectedTalukaFilter(e.value);
                    setOffset(0)
                  }}
                  options={[
                    { value: "", label: "All" },
                    ...filterTalukas?.map((e) => {
                      return { value: e.name, label: e.name }
                    }) ?? []]}
                  defaultOption={{ value: selectedTalukaFilter, label: selectedTalukaFilter || "Select Taluka" }}
                />
              </div>
            </div>
            <div className="col-md-12  col-lg-12 col-xl-2  col-12 d-flex align-items-center justify-content-end respoexportbtn ">
              <ButtonWithIcon
                text={"Export"}
                icon={PngImages.xlspic}
                onClick={handleExportClick}
              />
            </div>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table
              className="table mb-0 "
              id="dtHorizontalExample"
              cellSpacing="0"
              width="100%"
            >
              <thead>
                <tr className="table_heading">

                  <th scope="col" style={{ width: "5%" }}>
                    Sr No.
                  </th>
                  {/* <th scope="col" style={{ width: "15%" }}>
                                        Order ID
                                    </th> */}
                  <th scope="col" style={{ width: "10%" }}>
                    Order Date
                  </th>
                  <th scope="col" style={{ width: "15%" }}>
                    Package Name
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Student Name
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Email
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Mobile No.
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    View{" "}
                  </th>
                </tr>
              </thead>
              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    {/* <td>
                                            <label className="d-flex align-items-center justify-content-center">
                                                <input
                                                    className="cursor-pointer"
                                                    type="checkbox"
                                                    checked={item.isChecked || false}
                                                    style={{ height: "16px", aspectRatio: 1 }}
                                                    onChange={(value) => {
                                                        var updatedData = data;
                                                        updatedData[index].isChecked =
                                                            value.target.checked;
                                                        setData([...updatedData]);
                                                    }}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </td> */}
                    <td>{limit * offset + (index + 1)}</td>
                    {/* <td>{item.order_id}</td> */}
                    <td>{item.orderDate}</td>
                    <td>{truncatePackageNames(item.packages)}</td>
                    <td className="text-capitalize">
                      {item.userName + " " + item.lastName}
                    </td>
                    <td>{item.email}</td>
                    <td>{item.mobile}</td>
                    <td>
                      <a
                        className="cursor-pointer"
                        style={{ textDecoration: "underline" }}
                        onClick={() => {
                          setDetails(item);
                        }}
                      >
                        View
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {generatePaginationFooter(
            availableDataCount,
            limit,
            offset,
            setOffset
          )}
        </div>
      )}
      {/* <ConfirmationModal
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                text={
                    isMultipleDelete
                        ? "Are you sure want to delete selected Users?"
                        : "Are you sure want to delete User?"
                }
                icon={SvgImages.deleteIcon} // Specify the path to your delete icon
                rightClickAction={() => {
                    isMultipleDelete ? deleteMultipleuser() : deleteSingleUser(deleteId);
                }}
                theme={ConfirmationModalTheme.error}
            /> */}
    </div>
  );
};

export default PackagePurchased;
